import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "content-view"
};
import { computed, onMounted, ref } from "vue";
import router from '@/router';
import { pageStyle } from "@/theme/sliderStyle";
import { ElIcon, ElRow } from "element-plus";
import { ArrowLeftBold } from "@element-plus/icons-vue";
import RoleGenerator from "@/components/Role/RoleGenerator.vue";
import store from "@/store"; // refs

export default {
  __name: 'RoleGeneratorPage',

  setup(__props) {
    const roleId = ref(null);
    const role = computed(() => store.state.role_info[roleId.value]?.attribute ?? null); // functions

    const goBack = () => {
      router.back();
    }; // lifecycle


    onMounted(() => {
      roleId.value = router.currentRoute.value.params.roleId;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "page-container",
        style: _normalizeStyle(_unref(pageStyle))
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(ElRow), {
        class: "nav-bar",
        onClick: goBack
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElIcon), null, {
          default: _withCtx(() => [_createVNode(_unref(ArrowLeftBold))]),
          _: 1
        }), _cache[0] || (_cache[0] = _createElementVNode("text", {
          class: "left-nav-title"
        }, "回退", -1))]),
        _: 1
      }), _createVNode(RoleGenerator, {
        role: role.value,
        onCompleteRole: goBack
      }, null, 8, ["role"])])], 4);
    };
  }

};